<div class="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 animate-fade-in">
    <div class="mb-8">
        <h2 class="text-3xl font-extrabold text-gray-900 tracking-tight">Premium User List</h2>
        <p class="text-gray-500 mt-2">Manage and review active premium subscription members.</p>
    </div>

    <div class="bg-white rounded-[1.5rem] border border-gray-100 shadow-2xl overflow-hidden">
        <table class="w-full text-left border-collapse">
            <thead>
                <tr class="bg-gray-50/50 border-b border-gray-100">
                    <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest">User Profile</th>
                    <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest">Subscription Plan</th>
                    <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest">Contact Details</th>
                    <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest text-right">Actions</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-50">
                <tr (click)="openModal('user')" class="group hover:bg-indigo-50/30 transition-all duration-300 cursor-pointer">
                    <td class="px-8 py-6">
                        <div class="flex items-center gap-4">
                            <div class="relative w-16 h-16 rounded-2xl overflow-hidden shadow-md group-hover:shadow-indigo-100 transition-all border-2 border-white">
                                <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=facearea&facepad=2&w=150&h=150&q=80" 
                                     class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" alt="User Profile">
                            </div>
                            <div>
                                <p class="text-lg font-extrabold text-gray-900 group-hover:text-indigo-600 transition-colors">Amit Sharma</p>
                                <p class="text-sm text-gray-400 flex items-center mt-1">
                                    <span class="w-2 h-2 rounded-full bg-emerald-500 mr-2"></span>
                                    Active Now
                                </p>
                            </div>
                        </div>
                    </td>

                    <td class="px-8 py-6">
                        <div class="space-y-1">
                            <p class="text-xl font-black text-indigo-600">Enterprise</p>
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-bold bg-emerald-100 text-emerald-700 uppercase tracking-wider">
                                Annual Billing • Pro
                            </span>
                        </div>
                    </td>

                    <td class="px-8 py-6">
                        <div class="space-y-1.5">
                            <div class="flex items-center text-sm font-bold text-gray-700">
                                <svg class="w-4 h-4 mr-2 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                                amit.sharma&#64;email.com
                            </div>
                            <div class="flex items-center text-xs text-gray-500 font-medium">
                                <svg class="w-4 h-4 mr-2 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                                +91 98210 54321
                            </div>
                        </div>
                    </td>

                    <td class="px-8 py-6 text-right">
                        <button class="p-2 rounded-xl bg-gray-50 text-gray-400 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300 shadow-sm">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                            </svg>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

@if (isModalOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-md animate-backdrop" (click)="closeModal()">
      
        <div class="relative w-full max-w-lg bg-white rounded-[2.5rem] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-hidden animate-premium-modal" (click)="$event.stopPropagation()">
          
          <div class="h-28 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 relative">
              <div class="absolute -bottom-12 left-8 transition-transform hover:scale-110 duration-500">
                  <div class="relative">
                      <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=facearea&facepad=2&w=150&h=150&q=80" 
                           class="w-24 h-24 rounded-3xl border-4 border-white object-cover shadow-2xl" alt="User">
                      <span class="absolute bottom-1 right-1 bg-emerald-500 border-2 border-white w-5 h-5 rounded-full"></span>
                  </div>
              </div>
              <button (click)="closeModal()" class="absolute top-4 right-6 text-white/60 hover:text-white hover:rotate-90 transition-all duration-300">
                  <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
              </button>
          </div>
      
          <div class="pt-16 px-8 pb-8">
            
            <div class="flex justify-between items-start">
                <div>
                    <h2 class="text-3xl font-black text-gray-900 tracking-tight leading-tight">Amit Sharma</h2>
                    <p class="text-indigo-600 font-bold text-sm tracking-widest uppercase">Enterprise Member</p>
                </div>
                <span class="premium-glow inline-flex items-center px-4 py-1.5 rounded-full text-[11px] font-black uppercase bg-amber-400 text-white shadow-lg">
                    💎 VIP
                </span>
            </div>
      
            <div class="mt-8 grid grid-cols-2 gap-4">
                <div class="group flex items-center gap-3 p-4 bg-gray-50 rounded-2xl border border-transparent hover:border-indigo-100 hover:bg-white hover:shadow-md transition-all duration-300">
                    <div class="bg-indigo-100 p-2 rounded-xl text-indigo-600">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                    </div>
                    <div>
                        <p class="text-[10px] font-black text-gray-400 uppercase">Email</p>
                        <p class="text-sm font-bold text-gray-800">amit&#64;premium.com</p>
                    </div>
                </div>
                <div class="group flex items-center gap-3 p-4 bg-gray-50 rounded-2xl border border-transparent hover:border-indigo-100 hover:bg-white hover:shadow-md transition-all duration-300">
                    <div class="bg-indigo-100 p-2 rounded-xl text-indigo-600">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                    </div>
                    <div>
                        <p class="text-[10px] font-black text-gray-400 uppercase">Phone</p>
                        <p class="text-sm font-bold text-gray-800">+91 98210 54321</p>
                    </div>
                </div>
            </div>
      
            <div class="mt-8 p-6 bg-gray-900 rounded-[2.5rem] text-white relative shadow-2xl overflow-hidden group">
                <div class="absolute -top-10 -right-10 w-40 h-40 bg-indigo-500/30 blur-[60px] rounded-full group-hover:bg-indigo-500/50 transition-colors duration-700"></div>
                
                <div class="relative z-10">
                    <p class="text-[10px] font-black text-indigo-300 uppercase tracking-[0.2em] mb-4">Subscription Status</p>
                    <div class="flex justify-between items-center border-b border-white/10 pb-4 mb-4">
                        <div>
                            <p class="text-3xl font-black italic tracking-tighter uppercase leading-none">Enterprise</p>
                            <p class="text-[11px] text-white/40 mt-1 uppercase font-bold">Auto-Renews: Jan 2026</p>
                        </div>
                        <div class="text-right">
                            <p class="text-2xl font-black text-emerald-400">$299</p>
                            <p class="text-[10px] text-white/30 uppercase font-bold">Annual</p>
                        </div>
                    </div>
        
                    <div class="grid grid-cols-2 gap-6">
                        <div>
                            <p class="text-[10px] font-bold text-white/30 uppercase">Start Date</p>
                            <p class="text-sm font-black">Jan 15, 2025</p>
                        </div>
                        <div>
                            <p class="text-[10px] font-bold text-white/30 uppercase text-right">Expiry Date</p>
                            <p class="text-sm font-black text-pink-400 text-right">Jan 14, 2026</p>
                        </div>
                    </div>
                </div>
            </div>
      
            <div class="mt-8 flex gap-4">
                <button class="flex-1 bg-indigo-600 text-white font-black py-4 rounded-2xl hover:bg-indigo-700 hover:-translate-y-1 transition-all shadow-xl shadow-indigo-200 active:scale-95">
                    Extend Plan
                </button>
                <button (click)="closeModal()" class="px-8 border-2 border-gray-100 font-bold text-gray-400 rounded-2xl hover:bg-gray-50 hover:text-gray-600 transition-all active:scale-95">
                    Close
                </button>
            </div>
          </div>
        </div>
    </div>
    }